function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3335 3.00008H12.0002L10.3552 1.35508C9.91183 0.911748 9.31683 0.666748 8.6985 0.666748H2.66683C1.37183 0.666748 0.345163 1.70508 0.345163 3.00008L0.333496 17.0001C0.333496 18.2951 1.37183 19.3334 2.66683 19.3334H21.3335C22.6168 19.3334 23.6668 18.2834 23.6668 17.0001V5.33341C23.6668 4.05008 22.6168 3.00008 21.3335 3.00008ZM19.0002 12.3334H16.6668V14.6667C16.6668 15.3084 16.1418 15.8334 15.5002 15.8334C14.8585 15.8334 14.3335 15.3084 14.3335 14.6667V12.3334H12.0002C11.3585 12.3334 10.8335 11.8084 10.8335 11.1667C10.8335 10.5251 11.3585 10.0001 12.0002 10.0001H14.3335V7.66675C14.3335 7.02508 14.8585 6.50008 15.5002 6.50008C16.1418 6.50008 16.6668 7.02508 16.6668 7.66675V10.0001H19.0002C19.6418 10.0001 20.1668 10.5251 20.1668 11.1667C20.1668 11.8084 19.6418 12.3334 19.0002 12.3334Z",
  fill: "#007AFF"
});

function SvgAdditionalInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInformation);
export default __webpack_public_path__ + "static/media/additionalInformation.1f7154e0.svg";
export { ForwardRef as ReactComponent };